export default __webpack_public_path__ + "static/media/covetrus-journey.72c8b410.webp";